import { CoreIcon } from '../core-icon';
import helpSVG from '../../assets/icons/help.svg';
import type { IconProps } from '../core-icon';

export const HelpIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={helpSVG} {...props} />;
};
